export enum presetRangeType {
    today = 'today',
    thisWeek = 'this week',
    lastWeek = 'last week',
    thisMonth = 'this month',
    lastMonth='last month',
    thisYear='this year',
    lastYear='last year'
}